(function() { module.exports = window["Next"]["Loading"]; }());